import { render } from "./NutritionComponent.vue?vue&type=template&id=c27321b8&scoped=true"
import script from "./NutritionComponent.vue?vue&type=script&lang=js"
export * from "./NutritionComponent.vue?vue&type=script&lang=js"

import "./NutritionComponent.vue?vue&type=style&index=0&id=c27321b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27321b8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QLayout});
